'use client';

import React from 'react';

interface StorageCardProps {
  title: string;
  price: string;
  unit: string;
  description: React.ReactNode;
}

export default function StorageCard({
  title,
  price,
  unit,
  description
}: StorageCardProps) {
  return (
    <div className="flex flex-1 flex-col items-start p-7xl bg-white border border-gray-200 rounded-md shadow-lg min-w-0 overflow-hidden">
      <div className="flex flex-col gap-3xl items-start w-full">
        <div className="flex flex-col gap-2xs items-start w-full">
          <div className="flex gap-2xs items-center">
            <span className="font-semibold text-5xl leading-18xl text-gray-900 whitespace-nowrap">
              {title}
            </span>
          </div>
          <div className="flex gap-4xs items-end text-cic-blue-500 w-full whitespace-nowrap">
            <span className="font-semibold text-2xl leading-4xl">
              {price}
            </span>
            <span className="font-medium text-xl leading-3xl">
              {unit}
            </span>
          </div>
        </div>
        <div className="text-xs font-regular leading-xs text-gray-600 w-full">
          {description}
        </div>
      </div>
    </div>
  );
}
